<div class="container" *ngIf="params&&params.threadEntryType">
    <span (click)="closeGroup()">{{params.threadEntryType.name}}</span>
</div>